import React from 'react';
import { bool, func, string, node, oneOfType } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { isNil } from '../../utils/utils';

const propTypes = {
  open: bool.isRequired,
  title: oneOfType([string, node]),
  message: oneOfType([string, node]),
  onClose: func.isRequired,
  onSubmit: func,
};

const defaultProps = {
  title: <FormattedMessage id="modal.alert.title" defaultMessage="Information" />,
};

const AlertModal = ({ open, title, message, children, onClose, onSubmit, ...props }) => {
  const handleClick = (...params) => (onSubmit ? onSubmit(...params) : onClose(...params));
  return (
    <Modal toggle={onClose} isOpen={open} {...props} centered>
      <ModalHeader toggle={onClose}>{title}</ModalHeader>
      <ModalBody>{isNil(children) ? message : children}</ModalBody>
      <ModalFooter>
        <Button type="button" size="sm" color="primary" onClick={handleClick}>
          <FormattedMessage id="main.ok" defaultMessage="OK" />
        </Button>
      </ModalFooter>
    </Modal>
  );
};

AlertModal.propTypes = propTypes;
AlertModal.defaultProps = defaultProps;

export default AlertModal;
